<template>
    <CCard>
        <CCardBody>
            <v-toolbar flat color="white">
                <v-flex xs12 sm12 md4>
                    <v-toolbar-title>دسته بندی ها</v-toolbar-title>
                </v-flex>
                <v-spacer></v-spacer>
                <CButton color="info" class="mb-2 ml-2 text-white"
                         @click="addItem" v-if="!showCategoryTypes">
                    دسته بندی
                    جدید
                </CButton>
                <CButton v-if="!showCategoryTypes" color="primary" class="mb-2 ml-2 text-white"
                         @click="showCategoryTypesPage">
                    بازگشت به دسته بندی ها
                    <v-icon big
                            class="mr-2 text-white">
                        mdi-arrow-left-bold
                    </v-icon>
                </CButton>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{formTitle}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs8 sm8 md8>
                                        <CInput
                                                label="نام دسته بندی"
                                                v-model="editedItem.name_original"
                                                :is-valid="validations.name.isValid"
                                                :invalid-feedback="validations.name.error"
                                        />
                                    </v-flex>
                                    <v-flex xs4 sm4 md4 class="text-center">
                                        <p>وضعیت</p>
                                        <switches v-model="editedItem.status" theme="bootstrap"
                                                  color="primary"/>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <div class="form-group">
                                            <label>زیرمجموعه دسته بندی</label>
                                            <select class="form-control" v-model="editedItem.parent_id">
                                                <option value="">هیچ کدام</option>
                                                <option v-bind:value="category.category_id"
                                                        v-bind:key="category.category_id"
                                                        v-for="category in categories">{{category.name}}
                                                </option>
                                            </select>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton v-if="!showCategoryTypes" color="danger" class="mb-2 ml-2 text-white"
                                     @click="close">
                                انصراف
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                            <CButton v-if="!showCategoryTypes" color="primary" class="mb-2 ml-2 text-white"
                                     @click="save">
                                ذخیره
                                <CIcon :content="$options.iconsSet.cilSave"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="logDialog" max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">تاریخچه</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-data-table
                                                :headers="logsHeaders"
                                                :items="selectedItemLogs"
                                                sort-by="log_id"
                                                :hide-default-footer="true"
                                                :disable-pagination="true"
                                                class="elevation-1">
                                            <template v-slot:item="{item}">
                                                <tr>
                                                    <td>{{ item.log_id }}</td>
                                                    <td>{{ item.action }}</td>
                                                    <td>{{ item.user_fullname }}</td>
                                                    <td>{{ convertDateToJDate(item.set_date) }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="logDialog = false">
                                بستن
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
            <CCard v-if="!showCategoryTypes">
                <CCardHeader @click="collapse = !collapse">
                    <CIcon name="cil-justify-center"/>
                    <strong> فیلتر </strong>
                </CCardHeader>
                <CCollapse :show="collapse" :duration="400">
                    <CCardBody>
                        <CRow>
                            <CCol sm="2">
                                <CInput
                                        label="نام دسته بندی"
                                        v-model="filters.name"
                                />
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter class="text-left">
                        <CButton size="sm" color="primary" class="text-white" @click="loadCategoriesByType()">
                            <CIcon name="cil-check-circle"/>
                            اعمال
                        </CButton>
                        <CButton size="sm" color="danger" class="text-white mr-1" @click="resetFilters">
                            <CIcon name="cil-ban"/>
                            حذف فیلتر ها
                        </CButton>
                    </CCardFooter>
                </CCollapse>
            </CCard>
            <div v-if="showCategoryTypes">
                <v-data-table
                        :headers="categoryTypesHeader"
                        :items="categoryTypes"
                        :hide-default-footer="true"
                        sort-by="name"
                        :disable-pagination="true"
                        class="elevation-1">
                    <template v-slot:item="{item}">
                        <tr>
                            <td>{{ item.name }}</td>
                            <td>
                                <v-icon
                                        medium
                                        @click="showCategoryList(item)">
                                    mdi-database
                                </v-icon>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error">
                            جستجوی "{{ search }}" هیچ نتیجه ای در بر نداشت!
                        </v-alert>
                    </template>
                </v-data-table>
            </div>
            <div v-else>
                <CRow class="text-left" dir="ltr">
                    <CButton color="dark" class="mb-2 ml-2 text-white"
                             v-c-tooltip="'خروجی بصورت فایل PDF'"
                             @click="loadCategoriesByType('pdf')">
                        <CIcon :content="$options.iconsSet.cilFilePdf"/>
                    </CButton>
                    <CButton color="dark" class="mb-2 ml-2 text-white"
                             v-c-tooltip="'خروجی بصورت فایل اکسل'"
                             @click="loadCategoriesByType('excel')">
                        <CIcon :content="$options.iconsSet.cilFileExcel"/>
                    </CButton>
                </CRow>
                <v-data-table
                        :headers="categoryHeaders"
                        :items="categories"
                        :search="search"
                        :options.sync="categoryListOptions"
                        sort-by="name"
                        :hide-default-footer="true"
                        :disable-pagination="true"
                        loading-text="درحال بارگزاری"
                        no-data-text="موردی یافت نشد"
                        class="elevation-1">
                    <!--                <template v-slot:top>-->
                    <!--                    <v-text-field v-model="search" label="جستجو" class="mx-4 text-right"></v-text-field>-->
                    <!--                </template>-->
                    <template v-slot:item="{item}">
                        <tr>
                            <td @click="editItem(item,true)">{{ item.category_id }}</td>
                            <td @click="editItem(item,true)">{{ item.name }}</td>
                            <td>
                                <v-icon
                            v-c-tooltip="'ویرایش'"                                
                                        medium
                                        class="mr-2"
                                        @click="editItem(item)">
                                    mdi-pencil
                                </v-icon>
                                <v-icon
                            v-c-tooltip="'حذف'"                                
                                        medium
                                        @click="deleteAccount(item)">
                                    mdi-delete
                                </v-icon>
                                <v-icon
                            v-c-tooltip="'نمایش تاریخچه'"                                
                                        medium
                                        @click="showLogDialog(item)">
                                    mdi-information
                                </v-icon>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:no-results>
                        <v-alert :value="true" color="error">
                            جستجوی "{{ search }}" هیچ نتیجه ای در بر نداشت!
                        </v-alert>
                    </template>
                </v-data-table>
            </div>
        </CCardBody>
    </CCard>
</template>

<script>
    import {
        getCategories,
        categoryInfoAction,
        getCategoryTypes,
        functionAction,
        getFunction
    } from '../../webservice/webservice';
    import Switches from 'vue-switches';
    import {iconsSet} from '../../assets/icons/icons'
    import moment from "moment-jalaali";

    export default {
        name: 'Categories',
        iconsSet,
        props: {
            items: Array,
            fields: {
                type: Array,
                default() {
                    return ['username', 'registered', 'role', 'status']
                }
            },
            caption: {
                type: String,
                default: 'Table'
            },
            hover: Boolean,
            striped: Boolean,
            bordered: Boolean,
            small: Boolean,
            fixed: Boolean,
            dark: Boolean
        },
        components: {
            Switches
        },
        methods: {
            showCategoryList(item) {
                this.showCategoryTypes = false;
                this.selectedCategoryType = item.category_type_id;
                this.loadCategoriesByType();
            },
            showCategoryTypesPage() {
                this.showCategoryTypes = true;
                this.selectedCategoryType = '';
                this.categories = []
            },
            addItem() {
                this.clearValidation();
                this.editedItem = {
                    category_id: '',
                    name: '',
                    parent_id: '',
                    status: false,
                    category_type_id: '',
                };
                this.dialog = true
            },
            editItem(item) {
                this.clearValidation();
                this.editedIndex = this.categories.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                })
            },
            clearValidation(){
                Object.keys(this.validations).map((key) => {
                    this.validations[key].error = '';
                    this.validations[key].isValid = null;
                });
            },
            save() {
                this.clearValidation();
                this.editedItem.name = this.editedItem.name_original;
                delete this.editedItem.name_original;
                let action = this.editedIndex === -1 ? 'add' : 'update';
                this.editedItem.category_type_id = this.selectedCategoryType;
                let item = Object.assign({}, this.editedItem);
                item.status = item.status ? '1' : '0';
                functionAction(this.$http, 'categories', action, item).then((resp) => {
                    if (resp.success) {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        this.loadCategoriesByType();
                        this.close()
                    } else {
                        let errors = resp.body.errors;
                        
                        Object.keys(errors).map((k) => {
                            this.validations[k] = {isValid: false, error: errors[k]}
                        });
                    }
                });
            },
            resetFilters() {
                this.filters = {};
                this.loadCategoriesByType();
            },
            loadCategoriesByType(fileType) {
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    } else {
                        filters[key] = `%${filters[key]}%`;
                    }
                });
                if (this.selectedCategoryType !== '') {
                    filters['category_type_id'] = this.selectedCategoryType
                }
                getCategories(this.$http, (this.tableOption.page > 1) ? this.tableOption.itemsPerPage + this.tableOption.page + 1 : 0,
                    100, this.tableOption.sortedField, this.tableOption.sortDesc ? 'desc' : 'asc', filters, fileType).then((resp) => {
                    if (fileType !== undefined) {
                        if (fileType === 'pdf') {
                            window.open(resp.fileurl, '_blank');
                            return;
                        }
                        const link = document.createElement('a');
                        link.href = resp.fileurl;
                        link.setAttribute('download', 'accounts.' + ((fileType === 'pdf') ? 'pdf' : 'xls'));
                        document.body.appendChild(link);
                        link.click()
                    } else {
                        this.categories = resp.list;
                        this.categoriesCount = resp.count
                    }
                });
                this.filteredReq = filters;
            },
            deleteAccount(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {                 
                    Object.keys(item).map((key) => {
                        if (item[key] === null) {
                            item[key] = ''
                        }
                    });
                    if (!item.category_type_id) {
                        item.category_type_id = this.selectedCategoryType
                    }
                    categoryInfoAction(this.$http, 'delete', item).then((resp) => {
                        if (resp.success) {
                            this.$toasted.show(resp.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                            this.loadCategoriesByType();
                        } else {
                            this.$toasted.show("اطلاعات ارسالی اشتباه است.", {
                                theme: "toasted-danger",
                                position: "bottom-center",
                                duration: 5000
                            });
                        }
                    });
                }
            },
            showLogDialog(item) {
                this.logDialog = true;
                getFunction(this.$http, 'logs', 0, 1000, 'name', 'desc', {
                    "code": "category",
                    "code_id": item.category_id
                }).then((resp) => {
                    this.selectedItemLogs = resp.list
                })
            },
            convertDateToJDate(dt) {
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },
        },
        data: () => {
            return {
                dialog: false,
                categoryHeaders: [
                    {text: 'شناسه', value: 'name'},
                    {text: 'نام', value: 'name'},
                    {text: 'عملیات', value: 'actions', sortable: false},
                ],
                logsHeaders: [
                    {text: 'شناسه', value: 'log_id'},
                    {text: 'عملیات', value: 'action'},
                    {text: 'کاربر', value: 'user_fullname'},
                    {text: 'زمان', value: 'set_date'}
                ],                
                categoryTypesHeader: [
                    {text: 'نام', value: 'name'},
                    {text: 'نمایش زیرگروه ها', value: 'actions', sortable: false}
                ],
                categories: [],
                categoriesCount: 0,
                editedIndex: -1,
                editedItem: {
                    category_id: '',
                    name: '',
                    parent_id: '',
                    status: false,
                    category_type_id: '',
                },
                search: '',
                options: {},
                categoryListOptions: {},
                accountsCount: 0,
                collapse: false,
                filters: {
                    account_number: '',
                    name: '',
                    opening_balance: '',
                    description: '',
                    account_category_id: 0
                },
                validations: {
                    name: {isValid: null, error: ''}
                },
                tableOption: {
                    sortDesc: true,
                    sortedField: 'name',
                    itemsPerPage: 10,
                    page: 1
                },
                filteredReq: {},
                categoryTypes: [],
                showCategoryTypes: true,
                selectedCategoryType: '',
                logDialog: false,
                selectedItemLogs: []
            }
        },
        mounted() {
            getCategoryTypes(this.$http).then((resp) => {
                this.categoryTypes = resp
            });
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'دسته بندی جدید' : 'ویرایش دسته بندی'
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            categoryListOptions: {
                handler(value) {
                    this.tableOption.sortedField = value['sortBy'][0];
                    this.tableOption.sortDesc = value['sortDesc'][0];
                    this.tableOption.itemsPerPage = value.itemsPerPage;
                    this.tableOption.page = value.page;
                    getCategories(this.$http, (value.itemsPerPage * (value.page -1)),
                        value.itemsPerPage,
                        value['sortBy'][0],
                        value['sortDesc'][0] ? 'desc' : 'asc',
                        this.filteredReq).then((resp) => {
                        this.categories = resp.list;
                        this.accountsCount = resp.count
                    });
                },
                deep: true,
            },
        },
    }
</script>
